export class TagModel {  
    constructor(public name: string, public status: number, public id: string) { }
    // the status is 0 for old,1 for new and 2 for deleted
}
